import { environmentDetails } from '@bpd-library/utilities';
import { modalController } from '@molecules/modal';
import { videoLoader } from '@molecules/video/utilities';
import { IEModalController } from '@organisms/ie-modal/utilities/ie-modal-controller';
import { iframeModalController } from '@organisms/iframe-modal/utilities/iframe-modal-controller';
import { GTMTriggerController } from '@source/utilities/gtm-trigger';
import { checkLoggedInUser } from '@store/user';
import environment from '@utilities/environment';
import mockData from '@utilities/environment-mock-data';
import { inViewController } from '@utilities/inview-controller';
import { Loadable } from '@utilities/loadable';
import { LoadableModal } from '@utilities/loadable-modal';
import { serviceConsentTracker } from '@utilities/service-consent-tracker';

const loader = () => {
    /*
        Listen to Usercentrics events
    */
    serviceConsentTracker.init();

    /*
        Initialize shared repo environment details
    */
    if (environment.isLocal) {
        mockData.DeNieuweDefensie.TEST({ hasWishlist: true });
    }

    environmentDetails.init({
        environment: window.__ENVIRONMENT_DETAILS__.environment,
        apiBaseUrl: window.__ENVIRONMENT_DETAILS__.apiBaseUrl,
        languageIsoCode: window.__ENVIRONMENT_DETAILS__.languageIsoCode,
        mapboxAccessToken: window.__ENVIRONMENT_DETAILS__.mapbox.accessToken,
        mapboxStyle: window.__ENVIRONMENT_DETAILS__.mapbox.style,
        areaId: window.__ENVIRONMENT_DETAILS__.areaId,
    });

    /*
        Call controllers
    */
    modalController();
    iframeModalController();
    IEModalController();
    checkLoggedInUser();
    inViewController();
    videoLoader();
    GTMTriggerController();

    /*
        Call dynamically loaded components
    */
    Loadable({
        hook: 'apartments-view',
        loader: () => import('@source/components/molecules/apartments-view'),
    });

    Loadable({
        hook: 'bpd-properties',
        loader: () => import('@features/properties'),
    });

    Loadable({
        hook: 'bpd-map-current-area',
        loader: () => import('@source/components/molecules/map-current-area'),
    });

    Loadable({
        hook: 'bpd-wishlist',
        loader: () => import('@features/wishlist/wishlist'),
    });

    Loadable({
        hook: 'bpd-house-plans',
        loader: () => import('@organisms/house-plans/house-plans'),
    });

    const { loadManually: loadAreaSubscription } = Loadable({
        hook: 'bpd-area-subscription',
        loader: () => import('@features/area-subscription'),
    });

    Loadable({
        hook: 'area-subscription-de',
        loader: () => import('@molecules/area-subscription-de/utilities/area-subscription-de'),
    });

    Loadable({
        hook: 'bpd-compare',
        loader: () => import('@features/compare'),
    });

    Loadable({
        hook: 'smart-subscription',
        loader: () => import('@molecules/smart-subscription'),
    });

    Loadable({
        hook: 'hero-apartment',
        loader: () => import('@organisms/hero-apartment'),
    });

    Loadable({
        hook: 'message-form-inline',
        loader: () => import('@organisms/message-form-inline/utilities/message-form-inline'),
    });

    Loadable({
        hook: 'bpd-flyin-update',
        loader: () => import('@molecules/flyin-update/flyin-update'),
    });

    Loadable({
        hook: 'error-page',
        loader: () => import('@organisms/error-page'),
    });

    Loadable({
        hook: 'bpd-faq',
        loader: () => import('@organisms/faq/faq'),
    });

    Loadable({
        hook: 'area-map',
        loader: () => import('@features/area-map'),
    });

    Loadable({
        hook: 'virtual-tour-wrapper',
        loader: () => import('@source/features/virtual-tour'),
    });

    Loadable({
        hook: 'house-detailpage-cta',
        loader: () => import('@molecules/house-detailpage-cta/house-detailpage-cta'),
    });

    /*
        Call dynamically loaded modals
    */
    LoadableModal({
        name: 'mortgage-tool',
        loader: () => import('@features/mortgage-tool'),
    });

    LoadableModal({
        name: 'lead-form',
        loader: () => import('@organisms/lead-form'),
    });

    LoadableModal({
        name: 'brochure-form',
        loader: () => import('@organisms/brochure-form'),
    });

    LoadableModal({
        name: 'newsletter-form',
        loader: () => import('@organisms/newsletter-form'),
    });

    LoadableModal({
        name: 'message-form-modal',
        loader: () => import('@organisms/message-form-modal'),
    });

    LoadableModal({
        name: 'housing-module',
        loader: () => import('@organisms/housing-module'),
    });

    return { loadAreaSubscription };
};

export const { loadAreaSubscription } = loader();
